import { useRef, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Download } from "react-bootstrap-icons";
import { Button } from "./Controls/Button";
import { PageTitle } from "./Controls/PageTitle";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { Card, Col, Container, Row, Button as BsButton } from "react-bootstrap";
import { Facility, PlanDetails } from "./Data/ApiTypes";
import { connectUrl } from "./Data/ApiUrl";

type DownloadFormat = "svg" | "png";

interface QRCodeRef extends HTMLDivElement {
    querySelector( selectors: string ): SVGElement | null;
}

export function useParamIds() {
  const params = useParams();

  return {
    facilityId: Number(params.facilityId),
    rateProgramId: params.rateProgramId,
    isValidation: params.isValidation === "true",
    isDiscountValidationType: params.isDiscountValidationType === "true"
  };
}

export function FacilityRateSignPage() {
    const { facilityId, rateProgramId, isValidation, isDiscountValidationType } = useParamIds();
    const nav = useNavigate();
    const facility = useLoaderData() as Facility;
    // if rateProgramId exists, this is specific to an event "flat rate".
    const qrCodeUrl = (isDiscountValidationType) ? `/facility/${facilityId}/validation/redeem/${rateProgramId}` : (isValidation) ? `/facility/${facilityId}/validation/${rateProgramId}`:
     (rateProgramId) ? `/facility/${facilityId}/event/${rateProgramId}` : `/results/${facilityId}`;

    const [text, setText] = useState<string>( connectUrl( qrCodeUrl ) );
    const qrRef = useRef<QRCodeRef>( null );

    const downloadQR = ( format: DownloadFormat ): void => {
        const svg = qrRef.current?.querySelector( "svg" );
        if( !svg ) { return; }
        if( format === "svg" ) {
            const svgData = new XMLSerializer().serializeToString( svg );
            const blob    = new Blob( [svgData], { type: "image/svg+xml" } );
            const url     = URL.createObjectURL( blob );
            downloadFile( url, `qrcode.${format}` );
            URL.revokeObjectURL( url );
        } else {
            const canvas  = document.createElement( "canvas" );
            const ctx     = canvas.getContext( "2d" );
            const img     = new Image();
            const svgBlob = new Blob( [new XMLSerializer().serializeToString( svg )], { type: "image/svg+xml" } );
            const url     = URL.createObjectURL( svgBlob );

            img.onload = (): void => {
                canvas.width  = img.width;
                canvas.height = img.height;
                ctx?.drawImage( img, 0, 0 );
                const imgURI  = canvas.toDataURL( "image/png" );
                downloadFile( imgURI, "qrcode.png" );
                URL.revokeObjectURL( url );
            };
            img.src = url;
        }
    };

    const downloadFile = ( url: string, filename: string ): void => {
        const link    = document.createElement( "a" );
        link.href     = url;
        link.download = filename;
        document.body.appendChild( link );
        link.click();
        document.body.removeChild( link );
    };

    return <Container fluid className="h-100">
        <Row className="h-100 w-100">
            <Col className="h-100" style={{ display: "grid", gridTemplateRows: "auto 1fr auto auto 10px", gridTemplateColumns: "1fr" }}>
                <div className="d-flex align-items-center gap-2">
             
                    <BsButton variant="link" className="p-0" onClick={() => nav(-1)}>
                        ← Back
                    </BsButton>
                 
                    <PageTitle>
                      
                        {facility.name} {isValidation? 'Validation' : rateProgramId ? 'Event' : 'Hourly'} Sign
                    </PageTitle>
                </div>
                <div ref={qrRef} className="text-center h-100"
                                 style={{ minWidth: "0", minHeight: "0" }}>
                    <QRCodeSVG
                        height={512}
                        width={512}
                        style={{ objectFit: "contain", height: "100%" }}
                        value={text}
                        level="M"
                        includeMargin={true} />
                </div>
                <Card className="text-center mb-3">
                    <Card.Body>
                        <a target="_blank" href={text}>
                            {text}
                        </a>
                    </Card.Body>
                </Card>
                <div className="d-flex justify-content-center gap-3 d-print-none">
                    <Button className="w-100"
                        onClick={() => downloadQR( "svg" )}>
                        <Download className="me-2" />
                        Download SVG
                    </Button>
                    <Button className="border-success w-100"
                        onClick={() => downloadQR( "png" )}>
                        <Download className="me-2" />
                        Download PNG
                    </Button>
                </div>
            </Col>
        </Row>
    </Container>;
}